/** Width of the chart builder panel and per-dashboard AI assistant drawer (shared layout). */
export const SIDE_PANEL_WIDTH = '370px';

/** Shared inset from viewport right (px) for global AI FAB and overlay card. */
export const GLOBAL_AI_VIEWPORT_RIGHT_PX = 28;

/** Global AI assistant floating overlay card (Figma spec). */
export const GLOBAL_AI_OVERLAY_WIDTH = '340px';
/** Fixed card height (clamped to viewport so it stays above the FAB). */
export const GLOBAL_AI_OVERLAY_HEIGHT = 'min(480px, calc(100vh - 120px))';
export const GLOBAL_AI_OVERLAY_BOTTOM = '88px';
export const GLOBAL_AI_OVERLAY_RIGHT = `${GLOBAL_AI_VIEWPORT_RIGHT_PX}px`;
export const GLOBAL_AI_OVERLAY_Z_INDEX = 1400;

/** Global AI FAB: inset from viewport right (px). */
export const GLOBAL_AI_FAB_RIGHT_PX = GLOBAL_AI_VIEWPORT_RIGHT_PX;

/** Plot area inside each global-AI inline chart card (replots use height: 100% of this box). */
export const GLOBAL_AI_INLINE_CHART_PLOT_HEIGHT = '240px';

/**
 * Shorter plot area when a bar chart adapts to a single-value metric in the global AI chat preview
 * (avoids excess whitespace above/below the value).
 */
export const GLOBAL_AI_INLINE_CHART_METRIC_PLOT_HEIGHT = '112px';
